import { Box, Stack, Typography, TypographyProps } from '@mui/material';

export interface TypographyTitleProps extends TypographyProps {
  alwaysEnabled?: boolean;
  icon?: React.ReactNode;
  variant: 'h4' | 'subtitle1';
}

export const TypographyTitle = ({
  alwaysEnabled,
  icon,
  ...props
}: TypographyTitleProps) => {
  return (
    <Stack
      sx={{
        paddingTop: 2,
        paddingBottom: 1.5,
        justifyContent: '',
        alignItems: 'stretch',
        justifyItems: 'space-between',
      }}
      spacing={1}
      direction="row"
    >
      <Box sx={{ paddingTop: props.variant === 'h4' ? '2px' : undefined }}>
        {icon}
      </Box>
      <Typography {...props}>{props.children}</Typography>
    </Stack>
  );
};

//
